import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import SideNavigation from "../../Menu-sidenavbar/SideNavigation ";
import HeaderBackground from "../../../common/SubpagesBGimage";
import Footer from "../../Layout/Footer";
import Header from "../../Layout/Header";
import { StatutoryCommitteeActions } from "../../../Store/Statutory Committee/action";

function AntiRaggingCommittee() {
  const dispatch = useDispatch();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [openKeys, setOpenKeys] = useState([]);
  document.title = "Anti Ragging Committee | PSG-IAP"
  //  Fetch only if not already loaded
  useEffect(() => {
  if (!statutorySubpage?.length) {
    dispatch({ type: StatutoryCommitteeActions.GET_STATUTORY_COMMITTEE_SUBPAGE });
  }
}, []); // only on mount
 const statutorySubpage = useSelector(
    (state) => state.StatutoryCommitteeReducer.StatutoryCommitteeSubpage
  );

  //  Find Anti Ragging Committee from API
  const committeeData = statutorySubpage?.find(
    (item) => item.map_name === "Anti Ragging Committee"
  );

  if (!committeeData) {
    return (
      <div className="text-center mt-5">
        <div className="spinner-admission"></div>
        <p>Loading Anti-Ragging Committee...</p>
      </div>
    );
  }
  const chairman = committeeData?.statutory_chairman?.[0];
  const departments = committeeData?.departments || [];

  return (
    <div>
      <HeaderBackground
        menuName="About Us"
        subMenuName="Statutory Committee"
        thirdLevelName="Anti-Ragging Committee"
        handleMenuToggle={() => setIsMenuOpen(!isMenuOpen)}
      />
      <Header />

      <div className="statutory">
        <div className="container committee-container">
          <h6 className="rectangle-title">
            <span className="rectangle-marker"></span>
            {committeeData.committee_name}
          </h6>

          {/* <h2 className="main-title text-center flex-grow-1 mb-0">
            “RAGGING WITHIN OR OUTSIDE THE INSTITUTE IS STRICTLY PROHIBITED”
          </h2> */}
          <hr />

          {/*  Chairman */}
          {chairman && (
            <>
              <h5 className="mt-4 text-start subb-title">Chairman</h5>
              <div className="committee-info d-flex align-items-start mb-5">
                <div className="col-md-4 mb-3 committee-image">
                  <img
                    src={chairman.image || "/placeholder.jpg"}
                    alt={chairman.name || "Chairman"}
                    className="img-fluid rounded shadow img-thumbnail1"
                  />
                </div>
                <div className="committee-content text-left">
                  <p className="committee-name">{chairman.name}</p>
                  <p className="committee-position">{chairman.designation}</p>
                  <p className="committee-text mb-1">{chairman.address}</p>
                  <p className="committee-text mb-1">{chairman.city}</p>

                  <p className="committee-text mb-1">
                    <span className="label-blue">Phone:</span>{" "}
                    <span className="value-grey">{chairman.phone || "—"}</span>
                  </p>
                  <p className="committee-text mb-1">
                    <span className="label-blue">E-mail:</span>{" "}
                    <span className="value-grey">{chairman.email || "—"}</span>
                  </p>
                </div>
              </div>
            </>
          )}

          {/* Members */}
          {departments.map((dept, deptIdx) => (
            <div key={deptIdx} className="mb-5">
              <h5 className="mt-4 text-start subb-title">
                {dept.department_name}
              </h5>
              <div className="row mt-3">
                {dept.members.map((member, idx) => (
                 <div className="col-12 col-sm-6 col-lg-4 mb-4" key={idx}>
                    <div className="card member-card text-left p-4 shadow-sm">
                      <h5 className="member-name">{member.member_name}</h5>
                      <p className="member-title">{member.designation}</p>
                      <p className="member-title">{member.committee}</p>

                      {dept.department_name === "Representatives from Parents" ? (
                        <>
                          <p className="member-text">
                            <span className="label-blue">Mobile No:</span>{" "}
                            <span className="value-grey">
                              {member.phone || "—"}
                            </span>
                          </p>
                          <p className="member-text">
                            <span className="label-blue">E-mail:</span>{" "}
                            <span className="value-grey">
                              {member.email || "—"}
                            </span>
                          </p>
                        </>
                      ) : (
                        <>
                          {member.phone && (
                            <p className="member-text">
                              <span className="label-blue">Mobile No:</span>{" "}
                              <span className="value-grey">{member.phone}</span>
                            </p>
                          )}
                          {member.email && (
                            <p className="member-text">
                              <span className="label-blue">E-mail:</span>{" "}
                              <span className="value-grey">{member.email}</span>
                            </p>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>

      <SideNavigation
        key="About Us"
        isMenuOpen={isMenuOpen}
        handleMenuToggle={() => setIsMenuOpen(!isMenuOpen)}
        openKeys={openKeys}
        onOpenChange={setOpenKeys}
        defaultOpenSubMenu="About Us"
      />
      <Footer />
    </div>
  );
}

export default AntiRaggingCommittee;

